<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Vamos preencher as informações necessárias para a etapa de AIS
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-checkbox v-model="flagImportarAis">
          <template v-slot:label>
            <div style="color: #6e6e6e">Há necessidade de importar a SDI-001?</div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
  export default {
    data: () => ({
      flagImportarAis: false
    }),

    methods: {
      exportData() {
        return {
          flagImportarAis: this.flagImportarAis == false ? 0 : 1
        };
      }
    }
  };
</script>